import { Button, CoverImage, Fonts, TextSize, Weight } from 'components'

import { GLOBAL_COLORS } from 'theme'
import { css } from 'styled-components'
import styled from 'styled-components'

// wrapper styled component for mobile navigation header
export const MobileHeaderWrapper = styled.div`
  width: 100%;
  height: 60px;
  padding: 0 40px 0 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ theme }) => theme.mediaWidth.Mobile`
    padding: 0 40px 0 45px;
  `}
  ${({ theme }) => theme.mediaWidth.Tablet`
    padding: 0;
  `}
`

/**
 * Styling for the logo image
 */
export const Logo = styled(CoverImage)`
  width: 35px;
  height: 20px;
`

export const LogoWrapper = styled.a`
  width: 35px;
  height: 20px;
  transition: 0.4s all;
  cursor: pointer;
  &:hover {
    opacity: 0.7;
  }
`

export const WalletIcon = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  border-radius: 50%;
  &:hover {
    background-color: ${GLOBAL_COLORS.walletButton}33;
  }
  &:active {
    opacity: 0.7;
    background-color: ${GLOBAL_COLORS.walletButton}33;
  }
`

export const OpenMenuUnderlay = styled.div<{ isOpen: boolean }>`
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
  background: ${GLOBAL_COLORS.deepOceanBlue}33;
  z-index: 6;
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
`

export const OpenMenuWrapper = styled.div<{ isOpen: boolean }>`
  position: absolute;
  background-color: ${({ theme }) => theme.bg};
  ${({ isOpen }) =>
    !isOpen &&
    css`
      display: none;
    `}
  top: 60px;
  right: 0;
  width: 100%;
  height: calc(100vh - 60px);
  ${({ theme }) => theme.mediaWidth.Tablet`
    border-radius: 0 0 10px 10px;
  `}
`

export const MenuGroupWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: flex-end;
`

export const BurgerWrapper = styled.div`
  height: 24px;
  width: 24px;
  cursor: pointer;
  position: relative;
  border-radius: 50%;
  transition: 0.4s all;
  display: flex;
  justify-content: center;
  &:hover {
    background-color: ${GLOBAL_COLORS.walletButton}33;
  }
  &:active {
    opacity: 0.7;
    background-color: ${GLOBAL_COLORS.walletButton}33;
  }
`

export const OpenMenuContainerSettings = styled.div`
  position: relative;
  text-align: right;
  padding-bottom: 10px;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 0 10px;
`

export const OpenMenuContainerMain = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`
export const WalletLabel = styled.div<{ isDark: boolean }>`
  width: 188px;
  height: 48px;
  background: ${({ isDark }) =>
    isDark ? GLOBAL_COLORS.tidalBlue07 : GLOBAL_COLORS.walletLabelGrey};
  border-radius: 0 0 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: ${Weight.Regular};
  font-size: ${TextSize.four};
  cursor: pointer;
  transition: 0.4s all;
  ${({ theme }) => theme.mediaWidth.Tablet`
    border-radius: 0 0 10px 10px;
  `}
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.6;
  }
`

export const LayoutWrapperForMobile = styled.div`
  z-index: 7;
  background: ${({ theme }) => theme.bg};
`

export const MenuTitle = styled.div`
  display: flex;
`

export const MenuText = styled.span<{ isSelected: boolean }>`
  color: ${({ theme }) => theme.text1};
  font-weight: ${Weight.Bold};
  font-size: ${TextSize.two};
  font-family: ${Fonts.DMSans};
  opacity: ${({ isSelected }) => isSelected && 0.6};
  cursor: ${({ isSelected }) => isSelected && 'pointer'};
`

export const MenuTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 40px 0 45px;
  margin: 30px 0 15px;
  height: 24px;
`

export const MobileMenuItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-transform: capitalize;
  transition: 0.4s all;
  padding: 15px 50px 15px 45px;
  cursor: pointer;
  & > svg > path {
    stroke: ${({ theme }) => theme.seashellWhiteToDeepOceanBlue};
  }
  &:hover {
    background-color: ${({ theme }) => theme.nestedMenuHover};
  }
  &:active {
    opacity: 0.7;
    background-color: ${({ theme }) => theme.nestedMenuHover};
  }
`

export const ConnectWalletButton = styled(Button)`
  align-self: center;
  width: 100%;
  font-size: ${TextSize.four};
  font-weight: ${Weight.Medium};
  letter-spacing: -0.14px;
  height: 26px;
  padding: 0px 20px;
  background-color: ${GLOBAL_COLORS.walletButton};
  color: ${GLOBAL_COLORS.white};
`
